import {FC} from 'react';
import {Card, CardContent, Typography} from '@mui/material';
import {AdminBatchJob} from '../../../types/adminBatch.ts';
import {batchJobTypeLabel} from '../../../utils/batchUi.ts';

interface QualityJobDetailProps { job: AdminBatchJob; }

export const QualityJobDetail: FC<QualityJobDetailProps> = ({job}) => {
    return (
        <Card variant="outlined">
            <CardContent>
                <Typography variant="subtitle2">{batchJobTypeLabel(job.jobType)}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
                    이 작업 유형은 별도 결과 요약이 없습니다. 아래 submission 테이블에서 개별 결과를 확인하세요.
                </Typography>
            </CardContent>
        </Card>
    );
};
